import SmartSearch from '@components/dashboard-routes/SmartSearch/SmartSearch';
import React from 'react';

export default function SearchSessionsView(props) {
  return <SmartSearch {...props} />;
}
